import { useTranslation } from 'react-i18next';
import { z } from 'zod';
import { INTEGRATIONS_MAX_FORM_LIMIT } from '../lib/constants';

export const useFormSchemaUpdate = () => {
  const { t } = useTranslation('translation');

  const maxTitleMessage = t('common.formErrors.stringMaxLen', {
    max: INTEGRATIONS_MAX_FORM_LIMIT.title,
  });
  const maxCallbackUrlMessage = t('common.formErrors.stringMaxLen', {
    max: INTEGRATIONS_MAX_FORM_LIMIT.callbackUrl,
  });

  const baseFields = z
    .object({
      title: z.string().trim().max(INTEGRATIONS_MAX_FORM_LIMIT.title, maxTitleMessage).optional(),
      callbackUrl: z
        .string()
        .trim()
        .max(INTEGRATIONS_MAX_FORM_LIMIT.callbackUrl, maxCallbackUrlMessage)
        .optional(),
      method: z.enum(['GET', 'POST']).optional(),
    })
    .passthrough();

  return {
    baseFields,
  };
};
